(function () {
  const SCROLL_OFFSET = 88;

  function findSectionByKey(key) {
    if (!key) return null;
    return (
      document.querySelector(`[id^="shopify-section-"][id$="__${key}"]`) ||
      document.getElementById(`shopify-section-${key}`)
    );
  }

  function resolveTarget(link) {
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return null;

    const id = href.slice(1);
    return document.getElementById(id) || findSectionByKey(link.dataset.scrollFallback);
  }

  function scrollToElement(element) {
    if (!element) return;

    const top = element.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function setActiveLink(activeLink) {
    document.querySelectorAll('.product-page-anchor-nav__link[data-product-anchor]').forEach((link) => {
      link.classList.toggle('product-page-anchor-nav__link--active', link === activeLink);
    });
  }

  function handleAnchorClick(event) {
    const link = event.currentTarget;
    const target = resolveTarget(link);

    if (!target) return;

    event.preventDefault();
    scrollToElement(target);
    setActiveLink(link);

    if (history.replaceState) {
      history.replaceState(null, '', link.getAttribute('href'));
    }
  }

  function upgradeLegacyReviewLinks() {
    document.querySelectorAll('a[href="#reviews"]').forEach((link) => {
      link.setAttribute('href', '#product-customer-reviews');
      link.addEventListener('click', (event) => {
        event.preventDefault();
        scrollToElement(document.getElementById('product-customer-reviews'));
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-product-anchor]').forEach((link) => {
      link.addEventListener('click', handleAnchorClick);
    });

    upgradeLegacyReviewLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
